// @ts-nocheck
import * as R from 'ramda'

import { categoryNames } from 'components/common/JobProfileWidget/text'

const getCategories = R.pipe(
  R.values,
  R.map(([_label, _description, _explanation, category]) => category),
  R.uniq,
)

const getContent = language =>
  R.pipe(
    R.toPairs,
    R.reduce(
      (acc, [name, [label, description, explanation, category]]) => ({
        ...acc,
        [name]: { category, description, explanation, label },
      }),
      {},
    ),
  )(categoryNames(language))

export const getCategoryOrder = language => {
  const [first, second, third, fourth, fifth, sixth, seventh] = getCategories(
    categoryNames(language),
  )

  return [first, third, second, fifth, sixth, fourth, seventh]
}

export const getCompetencies = (fields, language) =>
  R.map(
    ({ name, ...rest }) => ({
      ...{ name, ...rest },
      ...getContent(language)[name],
    }),
    fields,
  )

export const getIsCompetenciesDisabled = formState => {
  const selectedCompetencies = formState.defaultValues.competencies?.filter(
    (competency, index) => {
      const dirtyFields = formState?.dirtyFields?.competencies
      const dirtyFieldsValue = dirtyFields
        ? (dirtyFields[index] || {})[competency.name]
        : false

      const hasChanged = !!dirtyFieldsValue

      return hasChanged !== competency[competency.name]
    },
  )

  return selectedCompetencies.length >= 5
}

export const getIsCompetencySelected = (name, formState) => {
  const defaultValue = formState?.defaultValues?.competencies?.filter(
    competency => competency.name === name,
  )[0][name]

  const isDirtyField =
    formState?.dirtyFields?.competencies?.filter(competency => competency[name])
      .length === 1

  return defaultValue !== isDirtyField
}
